(function () {
  function openItem(item, wrap) {
    item.setAttribute('open', '');
    wrap.style.height = '0px';
    var target = wrap.scrollHeight;
    requestAnimationFrame(function () {
      wrap.style.height = target + 'px';
    });
    var onEnd = function (e) {
      if (e.propertyName !== 'height') return;
      wrap.style.height = 'auto';
      wrap.removeEventListener('transitionend', onEnd);
    };
    wrap.addEventListener('transitionend', onEnd);
  }

  function closeItem(item, wrap) {
    var current = wrap.scrollHeight;
    wrap.style.height = current + 'px';
    wrap.offsetHeight;
    requestAnimationFrame(function () {
      wrap.style.height = '0px';
    });
    var onEnd = function (e) {
      if (e.propertyName !== 'height') return;
      item.removeAttribute('open');
      wrap.removeEventListener('transitionend', onEnd);
    };
    wrap.addEventListener('transitionend', onEnd);
  }

  function init() {
    document.querySelectorAll('[data-hgs-faq-list]').forEach(function (list) {
      list.classList.add('is-enhanced');
      var items = Array.prototype.slice.call(list.querySelectorAll('.hgs-faq__item'));

      items.forEach(function (item) {
        var summary = item.querySelector('summary');
        var wrap = item.querySelector('.hgs-faq__answer-wrap');
        if (item.open) {
          wrap.style.height = 'auto';
        }

        summary.addEventListener('click', function (e) {
          e.preventDefault();
          if (item.open) {
            closeItem(item, wrap);
            return;
          }
          items.forEach(function (other) {
            if (other !== item && other.open) {
              closeItem(other, other.querySelector('.hgs-faq__answer-wrap'));
            }
          });
          openItem(item, wrap);
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
